import PropTypes from 'prop-types';

import loadingImg from 'assets/img/loading.png';
import { cn } from 'utils';

import { Loader } from '../Loader';

export function ButtonContent({ prependIcon, disabled, loading, children }) {
  return (
    <span className="relative flex items-center justify-center w-full h-full">
      <>
        {prependIcon && (
          <span
            className={cn(
              'flex items-center justify-center mr-[8px]',
              disabled && '[&>svg]:fill-gainsboro'
            )}
          >
            {prependIcon}
          </span>
        )}
        {children}
        {loading && (
          <Loader
            src={loadingImg}
            alt="loading"
          />
        )}
      </>
    </span>
  );
}

ButtonContent.propTypes = {
  prependIcon: PropTypes.any,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.any,
};
